<template>
    <div>
        <div id="notifyPatientLocationUpdates" class="w3-container zero-left">
            <content-header v-bind:title="$t('patientAlerts')"></content-header>

            <span @click="clearAll">
                <i class="fa fa-trash w3-text-deep-orange w3-right w3-large w3-margin cursor-pointer" v-bind:title="$t('remove').concat(' ').concat($t('all'))"></i>
            </span>

            <div class="w3-container">

                <div v-if="sortedPatients.length < 1">
                    <h4 class="w3-container w3-center flow-blue-color">
                        {{ $t('noAlerts') }}
                    </h4>
                </div>

                <div v-else v-for="(p,index) in sortedPatients" class="w3-cell-row w3-panel w3-card-2 w3-round-medium w3-padding" v-bind:class="p.cls">
                    <div class="w3-container w3-cell w3-cell-top zero-left w3-border-right">
                        <p class="zero">{{ $t("arrived") }}</p>
                        <p class="zero w3-large">
                            {{ p.spottedTime }}
                        </p>
                    </div>

                    <div class="w3-container w3-cell w3-cell-middle">
                        <div class="w3-col">
                            <i class="fa fa-map-marker-alt flow-green-other-color flow-margin-right"></i>
                            <span class="zero w3-show-inline-block flow-margin-left w3-medium">{{ p.spottedLocation }}</span>
                        </div>

                        <div class="w3-col">
                        <span class="primary zero w3-show-inline-block w3-large">
                            <router-link target="_blank" :to="{ name: 'patient', params: { id: p.id }}" :title="$t('goToPatientDetail')">
                                {{ p.name }}
                            </router-link>
                        </span>
                        </div>

                        <div class="w3-col">
                            <span class="font-weight-bold flow-margin-right">{{ p.appointmentTime }}</span>
                            <span>{{ p.physician }}</span>
                            <span class="consultation-group flow-margin-left">- {{ p.group }}</span>
                        </div>
                    </div>
                    <div @click="remove(index)" class="w3-container w3-cell w3-cell-top w3-xlarge zero cursor-pointer">
                        &times;
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import PatientStatus from "../common/PatientStatus";
    import ContentHeader from "../common/ContentHeader";
    import {EventBus} from "../../main";

    const frc = Vue.prototype.$frc;

    export default {
        name: "NotifyPatientPositionUpdate",
        components: {ContentHeader, PatientStatus},
        props: ["group"],
        data() {
            return {
                prevPatients: [],
                toDisplay: [],
                patients: [],
                refreshTimeInMilli: 5000, // 5 seconds
                refreshId: undefined
            }
        },
        watch: {
            patients(newList) {
                this.compare(newList, this.prevPatients);
                this.prevPatients = this.generate(newList);
            },
            toDisplay(newList) {
                localStorage.setItem("patientAlerts", JSON.stringify(newList));
                EventBus.$emit("patientAlertsCount", newList ? newList.length : 0);
             }
        },
        mounted() {
            this.getPatients();
            var items = localStorage.getItem("patientAlerts");
            if (items) {
                this.toDisplay = JSON.parse(items)
            } else {
                this.toDisplay = [];
            }
        },
        beforeDestroy() {
            if (this.refreshId) clearTimeout(this.refreshId);
        },
        computed: {
            sortedPatients() {
                var result = this.toDisplay;

                result.sort(function (a, b) {
                    var aspo = a.spottedTime;
                    var bspo = b.spottedTime;

                    if (bspo) {
                        return bspo.localeCompare(aspo);
                    }

                    if (aspo) {
                        return aspo.localeCompare(bspo);
                    }

                    return 0;
                });

                return result;
            }
        },
        methods: {
            generate(patients) {
                var newList = [];
                const app = this;

                patients.forEach(function (p) {
                    if (p.status !== "AtWaitingArea" && p.status !== "InConsultation") {
                        newList[p.patientId] = app.generateLWObj(p);
                    }
                });

                return newList;
            },
            compare(newList, prevList) {
                var app = this;
                var newAlert = false;

                newList.forEach(function (np) {
                    var pp = prevList[np.patientId];
                    if (pp) {
                        if (np.status === "AtWaitingArea" || np.status === "InConsultation") {
                            var obj = app.generateLWObj(np);

                            for (var i = 0; i < app.toDisplay.length; i++) {
                                var item = app.toDisplay[i];
                                if (item && item.id === obj.id) {
                                    if (item.spottedTime !== obj.spottedTime || item.spottedLocation !== obj.spottedLocation) {
                                        newAlert = true;
                                    }
                                    app.toDisplay.splice(i, 1);
                                    break;
                                } else {
                                    newAlert = true;
                                }
                            }

                            if (!newAlert && app.toDisplay.length === 0) {
                                newAlert = true;
                            }

                            app.toDisplay.push(obj);
                        }
                    }
                });


                if (newAlert) {
                    EventBus.$emit("newPatientAlert");
                }
            },
            getPatients() {
                var gfilter = [this.group];
                var sFilter = Vue.getAllStatuses();

                var app = this;
                frc.getPatientsForWard(Vue.prototype.$currentWard.id, null, gfilter, sFilter).then(function (res) {
                    app.patients = res.data;
                    app.setTimer();
                }).catch(app.setTimer);
            },
            generateLWObj(entry) {
                return {
                    id: entry.patientId,
                    name: Vue.patientNamePlusId(entry.patientName, entry.internalIds),
                    physician: entry.physician.name,
                    group: entry.consultationGroup.displayName,
                    appointmentTime: entry.appointmentTime,
                    spottedTime: entry.lastSpotted ? entry.lastSpotted.time : '',
                    spottedLocation: entry.latestPosition ? entry.latestPosition.displayName : '',
                    status: entry.status
                };
            },
            setTimer() {
                this.refreshId = setTimeout(this.getPatients, this.refreshTimeInMilli);
            },
            remove(index) {
                this.toDisplay.splice(index, 1);
            },
            clearAll() {
                this.toDisplay = [];
            }
        }
    }
</script>

<style scoped>
</style>